import { render } from "./UserStatus.vue?vue&type=template&id=2e43b61a"
import script from "./UserStatus.vue?vue&type=script&lang=ts"
export * from "./UserStatus.vue?vue&type=script&lang=ts"
script.render = render

export default script